import axios, { resHandle } from "@/plugins/axios";

/**
 * @description 大屏看板
 */
const GetBoard = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/user/admin_patient_board", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取大屏机构数据
 */
const GetFlatList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/institution/get_institution_flat_list", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
export { GetBoard, GetFlatList }

